import React from "react";
export default function Loader() {
  return <div style={{ padding: 40, textAlign: "center" }}>Loading...</div>;
}
